module.exports = __webpack_public_path__ + "img/teamsInactive.4e2e292c.svg";